import invariant from "invariant";

// Parse the JWT payload
const parseToken = (token) => JSON.parse(atob(token.split(".")[1]));

export class Token {
    constructor(raw) {
        invariant(typeof raw === 'string' && raw.startsWith('ey'), `Raw ${raw} is not a JWT`);
        this.token = raw;
        this.payload = parseToken(raw);
    }

    get authorizationHeader() {
        return `Bearer ${this.token}`;
    }

    /** The expiration timestamp of the token*/
    get expire() {
        return this.payload.exp;
    }

    /** is true if the token is expired */
    get isExpired() {
        return Date.now() / 1000 > this.expire;
    }

    getAccountInfo() {
        return this.payload.data;
    }
}
